// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  initializeAuth,
  browserPopupRedirectResolver,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: 'AIzaSyAEH63SPgypYqt4lDVsZx0r2kz6e-29xnQ',
  authDomain: 'sportsbuff.co.uk',
  projectId: 'sportsbuff-ef5d8',
  // (storageBucket value doesn't affect Auth; keep whatever your app needs)
  storageBucket: 'sportsbuff-ef5d8.firebasestorage.app',
  messagingSenderId: '770153098914',
  appId: '1:770153098914:web:6f5bc64376523d613a71fb',
};

const app = initializeApp(firebaseConfig);

const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
  popupRedirectResolver: browserPopupRedirectResolver,
});

const provider = new GoogleAuthProvider();
provider.setCustomParameters?.({ prompt: "select_account" });

const db = getFirestore(app);
const storage = getStorage(app);

export { auth, provider, db, storage };
